import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import AuthAxios from "../../config/authAxios"
import apiRoutes from "../apiConfigs"

export const classDetailsApi = createAsyncThunk(
    'auth/class/details',
    async (id, { rejectWithValue }) => {
        try {
            const response = await AuthAxios.get(apiRoutes.classesAction(`${id}`, 1))
            return response?.data
        } catch (error) {
            return rejectWithValue(error?.response?.data)
        }
    }
)
const intialState = { result: [], loading: false, error: null, message: "" }
const classDetailsSlice = createSlice({
    name: 'class details',
    initialState: { result: [], loading: false, error: null, message: "" },
    reducers: {
        resetclass: () => intialState,
      },
    extraReducers: (builder) => {
        builder.addCase(classDetailsApi.pending, (state, action) => {
            state.loading = true
        })
        builder.addCase(classDetailsApi.fulfilled, (state, action) => {
            state.loading = false
            state.result = action?.payload?.result
            state.message = action?.payload?.message
        })
        builder.addCase(classDetailsApi.rejected, (state, action) => {
            state.loading = false
            state.error = action?.payload?.error
            state.message = action?.payload?.message
        })
    },
})
export const {  resetclass } = classDetailsSlice.actions;
export const classDetailsReducer = classDetailsSlice.reducer